import Button from '@blaze-react/button';
import PropTypes from 'prop-types';
import { useState } from 'react';
import PhoneButtonContent from './PhoneButtonContent';
import { DATA_LAYER_OPTIONS } from '../../constants';
import { buildTransactionId, pushPurchase } from '../../utils/data-layer';
import { extractListingDataLayerData } from '../../utils/transformers';

const EcommercePhoneButton = ({ contacts, disableClicks, yachtData }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleClick = () => {
    if (disableClicks) return;

    const dataLayerPayload = extractListingDataLayerData(yachtData, contacts);

    const transactionId = buildTransactionId(yachtData.id);
    pushPurchase(dataLayerPayload, DATA_LAYER_OPTIONS.PHONE, transactionId);

    setModalOpen(true);
  };

  return (
    <>
      <Button
        className="ecommerce__buttons__button ecommerce__buttons__button--phone"
        title="Call broker"
        onClick={handleClick}>
        Call broker
      </Button>

      {isModalOpen && <PhoneButtonContent close={() => setModalOpen(false)} contacts={contacts} />}
    </>
  );
};

EcommercePhoneButton.propTypes = {
  contacts: PropTypes.array.isRequired,
  disableClicks: PropTypes.bool,
  yachtData: PropTypes.object.isRequired
};

EcommercePhoneButton.defaultProps = {
  disableClicks: false
};

export default EcommercePhoneButton;
